(function() {
  function init() {
    document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(function (root) {
      if (root.dataset.kkHeroBound === '1') return;
      root.dataset.kkHeroBound = '1';
      bindHero(root);
    });
  }

  function parseJSONAttr(root, name) {
    try { return JSON.parse(root.getAttribute(name) || '[]'); } catch (e) { return []; }
  }

  function bindHero(root) {
  var sectionId = root.dataset.section;
  var thumbs = root.querySelectorAll('.pdp-gallery__thumb');
  var mainImg = root.querySelector('.pdp-gallery__main-img');
  // Liquid-generated URL lists live in JSON data attributes on <product-info>
  var mainUrls = parseJSONAttr(root, 'data-kk-main-urls');
  var fullUrls = parseJSONAttr(root, 'data-kk-full-urls');
  var mediaIds = parseJSONAttr(root, 'data-kk-media-ids');
  var mediaAlts = parseJSONAttr(root, 'data-kk-media-alts');
  var variants = parseJSONAttr(root, 'data-kk-variants');
  // A required bundle component is sold out (kkumi-bundle-blockers, rendered
  // as data-kk-blocked): no variant can be bought, whatever Shopify counts.
  // data-kk-blocked-notify: Notify me may show even on a variant Shopify
  // counts in stock (the wishlist worker checks components too).
  var blocked = root.hasAttribute('data-kk-blocked');
  var blockedNotify = root.hasAttribute('data-kk-blocked-notify');
  function sellable(v) { return !!(v && v.available && !blocked && (v.stockState !== 'unavailable' || root.dataset.kkPreorder === 'true')); }
  function physical(v) { return !!(v && v.physical === true && !blocked); }
  // Belt and braces: with Add to cart disabled no shopper can submit, but a
  // script or a stale button must not start an add either. global.js adds
  // from a document capture listener, so this one sits on window. (The
  // notify modal's form lives in <body>, outside the product form.)
  if (blocked) {
    window.addEventListener('submit', function (evt) {
      var f = evt.target;
      if (!f || !root.contains(f) || !f.closest('product-form')) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }, true);
  }
  var variantDescription = root.querySelector('[data-kk-variant-description]');
  var current = 0;
  thumbs.forEach(function(t, i) { if (t.classList.contains('is-active')) current = i; });
  var strip = root.querySelector('.pdp-gallery__thumbs');
  var cap = root.querySelector('[data-kk-cap]');
  var capAlt = cap && cap.querySelector('[data-kk-cap-alt]');
  var capN = cap && cap.querySelector('[data-kk-cap-n]');
  var titleEl = root.querySelector('.pdp-buy__title');
  var mainBox = mainImg && mainImg.parentElement; // .pdp-gallery__main
  var preloaded = {}; // url -> true once an Image() has been kicked off

  function kickPreload(url) {
    if (!url || preloaded[url]) return;
    preloaded[url] = true;
    var im = new Image();
    im.src = url;
  }

  // Idle-time preload of all media so the first click is usually instant.
  function backgroundPreload() { mainUrls.forEach(kickPreload); }
  if ('requestIdleCallback' in window) requestIdleCallback(backgroundPreload, { timeout: 2000 });
  else setTimeout(backgroundPreload, 200);

  // Idempotent writes: never touch a text node that already says the right
  // thing (MutationObserver feedback-loop rule, FRONTEND.md).
  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  // Caption chip: alt text of the shown photo + "2/14" (merchant format),
  // counted over the thumbnails currently shown, so it follows the variant
  // images filter (which hides the other option values' photos).
  function syncCaption(idx) {
    if (!cap) return;
    var alt = typeof mediaAlts[idx] === 'string' ? mediaAlts[idx].trim() : '';
    var pos = 0, total = 0;
    thumbs.forEach(function(t, i) {
      if (t.hidden) return;
      total++;
      if (i === idx) pos = total;
    });
    if (!thumbs.length) { total = mainUrls.length; pos = idx + 1; }
    var n = '';
    if (total > 1 && pos > 0) {
      n = (cap.dataset.countFormat || '[current]/[total]')
        .split('[current]').join(String(pos))
        .split('[total]').join(String(total));
    }
    setText(capAlt, alt);
    setText(capN, n);
    cap.hidden = !alt && !n;
  }

  // Keep the active thumbnail visible in a scrolling rail. A variant whose
  // image is the 12th of 14 used to light up a thumbnail scrolled out of
  // sight. Scrolls the strip only (never the page), and only when the
  // thumbnail isn't already fully in view, centring it.
  function revealThumb(idx) {
    var t = thumbs[idx];
    if (!strip || !t) return;
    var sb = strip.getBoundingClientRect();
    var tb = t.getBoundingClientRect();
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var vertical = strip.scrollHeight - strip.clientHeight > strip.scrollWidth - strip.clientWidth;
    if (vertical) {
      if (tb.top >= sb.top && tb.bottom <= sb.bottom) return;
      strip.scrollTo({ top: strip.scrollTop + (tb.top - sb.top) - (sb.height - tb.height) / 2, behavior: smooth ? 'smooth' : 'auto' });
    } else {
      if (tb.left >= sb.left && tb.right <= sb.right) return;
      strip.scrollTo({ left: strip.scrollLeft + (tb.left - sb.left) - (sb.width - tb.width) / 2, behavior: smooth ? 'smooth' : 'auto' });
    }
  }

  // Videos (phase 7): the stage shows the poster; the play button loads the
  // player from its <template>. Any other pick removes the player.
  var playBtn = root.querySelector('[data-kk-play]');
  var videoTpls = {};
  Array.prototype.forEach.call(root.querySelectorAll('template[data-kk-video-tpl]'), function (t) {
    videoTpls[t.getAttribute('data-kk-video-tpl')] = t;
  });
  function stopVideo() {
    if (!mainBox) return;
    var player = mainBox.querySelector('.pdp-gallery__video');
    if (player) player.remove();
    mainBox.classList.remove('is-playing');
  }
  function syncPlay(idx) {
    if (!playBtn) return;
    var id = String(mediaIds[idx] == null ? '' : mediaIds[idx]);
    var isVideo = !!videoTpls[id];
    if (playBtn.hidden === isVideo) playBtn.hidden = !isVideo;
    playBtn.dataset.video = isVideo ? id : '';
  }
  if (playBtn) {
    playBtn.addEventListener('click', function () {
      var tpl = videoTpls[playBtn.dataset.video];
      if (!tpl || !mainBox) return;
      stopVideo();
      var player = document.createElement('div');
      player.className = 'pdp-gallery__video';
      player.appendChild(tpl.content.cloneNode(true));
      mainBox.appendChild(player);
      mainBox.classList.add('is-playing');
      playBtn.hidden = true;
      var v = player.querySelector('video');
      if (v) {
        var started = v.play && v.play();
        if (started && started.catch) started.catch(function () {});
        v.focus();
      }
    });
    syncPlay(current);
  }

  function showMedia(idx) {
    var url = mainUrls[idx];
    if (!url || !mainImg) return;
    // Already playing this video: leave the player alone.
    if (idx === current && mainBox && mainBox.classList.contains('is-playing')) return;
    stopVideo();
    current = idx;
    thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
    syncCaption(idx);
    revealThumb(idx);
    syncPlay(idx);

    // Drive loading state off the actual <img> rather than a phantom preloader.
    if (mainImg.srcset) mainImg.removeAttribute('srcset');
    if (mainImg.src === url) return; // already showing it

    var done = function() { if (mainBox) mainBox.classList.remove('is-loading'); };
    mainImg.addEventListener('load',  done, { once: true });
    mainImg.addEventListener('error', done, { once: true });

    if (mainBox) mainBox.classList.add('is-loading');
    // Alt follows the shown image; Liquid's own fallback (the product title)
    // when the image has none.
    var alt = typeof mediaAlts[idx] === 'string' ? mediaAlts[idx].trim() : '';
    if (!alt && titleEl) alt = titleEl.textContent.trim();
    if (alt && mainImg.alt !== alt) mainImg.alt = alt;
    mainImg.src = url;

    // If the browser already had it cached, load may not fire — peek.
    if (mainImg.complete && mainImg.naturalWidth > 0) done();
    else if (!preloaded[url]) preloaded[url] = true;
  }

  // Variant images: each variant's `images` (its custom.variant_images media
  // ids) groups photos by the value of ONE option (data-kk-vi-index). Showing
  // a value = its own photos + every photo no variant claims (shared/default
  // shots); with none of its own, just the shared ones; with nothing left,
  // everything. Liquid renders the first state; this keeps it in step.
  // A variant without its own list (when others have one) claims its Shopify
  // variant image, never the cover (mediaIds[0]). Filtering waits for the
  // shopper's first pick in that option: a pre-selected value shows the
  // whole gallery (data-kk-vi-armed: the URL named a variant, Liquid filtered).
  var viIndex = root.hasAttribute('data-kk-vi-index') ? parseInt(root.getAttribute('data-kk-vi-index'), 10) || 0 : -1;
  var viGroups = {};   // option value -> { mediaId: true }
  var viClaimed = {};  // mediaId -> true
  var viActive = false;
  var viArmed = root.hasAttribute('data-kk-vi-armed');
  if (viIndex >= 0) {
    var viClaim = function(val, id) {
      viClaimed[id] = true;
      (viGroups[val] = viGroups[val] || {})[id] = true;
    };
    var viListed = function(v) { return (v.images || []).some(function(id) { return !!id; }); };
    var viAny = variants.some(viListed);
    variants.forEach(function(v) {
      var val = (v.options || [])[viIndex];
      if (viListed(v)) {
        v.images.forEach(function(id) { if (id) viClaim(val, id); });
      } else if (viAny && v.media && v.media !== mediaIds[0]) {
        viClaim(val, v.media);
      }
    });
    viActive = Object.keys(viClaimed).length > 0;
  }
  var refreshThumbStrip = function() {};

  // Hide the other values' thumbs; returns the index to show, or -1 when the
  // caller should fall back to the variant's featured image.
  function applyVariantImages(v) {
    if (!viActive || !viArmed || !v) return -1;
    var group = viGroups[(v.options || [])[viIndex]] || {};
    var visible = mediaIds.map(function(id) { return !viClaimed[id] || !!group[id]; });
    if (visible.indexOf(true) < 0) visible = mediaIds.map(function() { return true; });
    var tpl = thumbsCol && thumbsCol.getAttribute('data-kk-thumb-aria');
    var n = 0;
    thumbs.forEach(function(t, i) {
      var on = !!visible[i];
      if (t.hidden === on) t.hidden = !on;
      if (on) {
        n++;
        if (tpl) t.setAttribute('aria-label', tpl.split('{n}').join(String(n)));
      }
    });
    if (thumbsCol) {
      // Overflow (fade + pager) is measured by refreshThumbStrip below; this
      // count-based guess only covers a strip without a pager.
      var max = parseInt(thumbsCol.getAttribute('data-kk-thumb-max'), 10) || 4;
      thumbsCol.classList.toggle('has-overflow', n > max);
      thumbsCol.scrollTop = 0;
      thumbsCol.scrollLeft = 0;
    }
    refreshThumbStrip();
    var featured = mediaIds.indexOf(v.media);
    if (featured >= 0 && visible[featured]) return featured;
    for (var i = 0; i < mediaIds.length; i++) if (visible[i] && group[mediaIds[i]]) return i;
    if (visible[current]) return current;
    return visible.indexOf(true);
  }

  // Point the gallery at a selected variant: filter, then show its image.
  function syncGallery(v, featuredId) {
    var idx = applyVariantImages(v);
    if (idx < 0 && featuredId) idx = mediaIds.indexOf(featuredId);
    if (idx >= 0) showMedia(idx);
  }

  thumbs.forEach(function(t, idx) {
    t.addEventListener('click', function(e) { e.preventDefault(); showMedia(idx); });
    t.addEventListener('mouseenter', function() { kickPreload(mainUrls[idx]); }, { passive: true });
  });

  // Opened on a variant's image further down the list (?variant= link):
  // bring its thumbnail into view once the rail has its size.
  if (current > 0) {
    var revealStart = function () { revealThumb(current); };
    if (document.readyState === 'complete') requestAnimationFrame(revealStart);
    else window.addEventListener('load', revealStart, { once: true });
  }

  // Variant change → swap main image to the new variant's featured media.
  // Shopify's product-info.js only auto-updates galleries wrapped in
  // <media-gallery>; ours isn't, so subscribe to the variantChange event
  // it publishes AFTER the fetch resolves and read the variant directly.
  // (A setTimeout on the radio's 'change' event reads stale JSON because
  // the variant-selects element hasn't been replaced yet.)
  // Force the Add-to-cart button + form input to match a variant object,
  // bypassing Dawn's product-form.toggleSubmitButton (unreliable in the modal).
  function syncAtc(v) {
    if (!v) return;
    v = variantById(v.id) || v;
    var atc = root.querySelector('.kk-pdp-atc-btn');
    if (atc) atc.dataset.availableLabel = v.stockState === 'backorder' ? atc.dataset.backorderLabel : atc.dataset.normalLabel;
    root.querySelectorAll('[data-kk-backorder-fields] input').forEach(function (input) { input.disabled = v.stockState !== 'backorder' || !sellable(v); });
    var note = root.querySelector('[data-kk-backorder-note]');
    if (note) note.hidden = v.stockState !== 'backorder' || !sellable(v);
    if (atc) {
      // Clear any stuck Dawn loading state so the label is never left blank.
      atc.classList.remove('loading');
      var spinner = atc.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
      var label = atc.querySelector('span');
      if (sellable(v)) {
        atc.removeAttribute('disabled');
        // data-available-label carries the merchant's ATC copy ("Pre-order" on a
        // pre-order product), which the generic variantStrings would overwrite.
        if (label) label.textContent = atc.dataset.availableLabel || (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      } else {
        atc.setAttribute('disabled', 'disabled');
        if (label) label.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      }
    }
    var input = root.querySelector('product-form input[name="id"]');
    if (input && v.id) input.value = v.id;
    // Setting .value fires no `change`, so move the pre-order selling plan too.
    var form = root.querySelector('product-form');
    if (form && form.sellingPlanInput && typeof form.syncPreorderPlan === 'function') form.syncPreorderPlan();
  }

  // The selected variant's pre-order selling plan id ('' when none), from the
  // map the selling_plan input carries (snippets/kkumi-preorder-plan).
  function preorderPlanFor(id) {
    var planInput = root.querySelector('product-form input[name="selling_plan"][data-kk-po-plans]');
    if (!planInput) return '';
    try { return JSON.parse(planInput.dataset.kkPoPlans || '{}')[id] || ''; } catch (e) { return ''; }
  }

  // --- Everything below follows the selected variant but is NOT in Dawn's
  // fetch-and-swap id list. product-info.js only refreshes nodes named
  // `<id>-<sectionId>`; the price has one, these do not, so before this they
  // stayed frozen on whichever variant rendered first.

  // Extra sticker sheets ticked / stepped in the "extra sheets" block
  // (assets/kkumi-extra-sheets.js) ride the same Add to cart press, so the
  // button price and the instalment widget count them. Their own cents, in
  // the shopper's market currency like the variant prices.
  function extraSheetsCents() {
    return window.KKExtraSheets ? window.KKExtraSheets.totalCents(root) : 0;
  }

  function currentQty() {
    var q = root.querySelector('.quantity__input');
    var n = q ? parseInt(q.value, 10) : 1;
    return (isFinite(n) && n > 0) ? n : 1;
  }

  // The stock badge used to be two Liquid branches, so it kept saying "In stock"
  // on a sold-out option. Labels ride data-* so merchant copy still owns them.
  function syncStock(v) {
    var badge = root.querySelector('[data-kk-stock]');
    if (!badge) return;
    var label = badge.querySelector('.pdp-buy__stock-label');
    var text = sellable(v) ? (v.stockState === 'backorder' ? root.dataset.backorderBadge : badge.dataset.inStock) : badge.dataset.outOfStock;
    // Idempotent write — an unconditional textContent set re-fires childList
    // observers watching this subtree (the /cart.js flood pattern).
    if (label && text && label.textContent !== text) label.textContent = text;
    badge.classList.toggle('pdp-buy__stock--out', !sellable(v));
  }

  // Buy it now was a static link holding the first-rendered variant and a
  // hard-coded quantity of 1 — pressing it after changing an option checked out
  // the wrong variant at the wrong price. Rebuild it from the live selection,
  // and strip the href entirely when the selection can't be bought.
  function syncBuyNow(v) {
    var a = root.querySelector('[data-kk-buynow]');
    if (!a) return;
    if (sellable(v) && v.id && v.stockState !== 'backorder') {
      // A cart permalink takes the selling plan as a query param — without it a
      // pre-order checked out through here would skip the pre-order plan.
      var plan = preorderPlanFor(v.id);
      // Extra sheets join the permalink as more `id:qty` pairs — except on a
      // pre-order, where the selling plan param must stay unambiguous.
      var pairs = v.id + ':' + currentQty();
      if (!plan && window.KKExtraSheets) {
        var form = root.querySelector('product-form form');
        window.KKExtraSheets.items(form).forEach(function (it) { pairs += ',' + it.id + ':' + it.quantity; });
      }
      a.setAttribute('href', (a.dataset.kkBuynowBase || '/cart') + '/' + pairs + '?' + (plan ? 'selling_plan=' + plan + '&' : '') + 'return_to=/checkout');
      a.removeAttribute('aria-disabled');
    } else {
      a.removeAttribute('href');
      a.setAttribute('aria-disabled', 'true');
    }
  }

  // Sold-out selection swaps Buy it now for the restock "Notify me" slot
  // (only rendered when some variant is sold out). The signed-up done state
  // on the button itself is owned by kkumi-notify-modal.js.
  function syncNotify(v) {
    var slot = root.querySelector('[data-kk-notify-slot]');
    if (!slot) return;
    // Blocked by a component on a variant Shopify still counts in stock:
    // Notify me only when the theme setting allows it (see the hero Liquid).
    var soldOut = !physical(v) && (!blocked || !v.available || blockedNotify);
    if (slot.hidden === soldOut) slot.hidden = !soldOut;
    var a = root.querySelector('[data-kk-buynow]');
    if (a && a.hidden !== soldOut) a.hidden = soldOut;
    // The modal signs up for the selected variant (restock digest).
    // Dawn's ModalDialog moves itself to <body>, so find it by id, not root.
    var modal = document.getElementById('KkNotify-pdp-' + sectionId);
    var form = modal && modal.querySelector('form[data-kk-notify]');
    if (form && soldOut && v.id) form.dataset.kkRestockVariant = String(v.id);
    // The trigger's "already signed up" state is per variant: retarget it,
    // then let kkumi-notify-modal.js flip it to done / idle to match.
    var trigger = slot.querySelector('[data-kk-notify-trigger]');
    if (trigger && soldOut && v.id) {
      var key = String(trigger.getAttribute('data-kk-notify-trigger') || '').split(':')[0] + ':' + v.id;
      if (trigger.getAttribute('data-kk-notify-trigger') !== key) {
        trigger.setAttribute('data-kk-notify-trigger', key);
        if (window.KKNotify) window.KKNotify.sync();
      }
    }
  }

  // Afterpay's instalment figure is an app block: Shopify renders it once and the
  // theme never re-renders it, so it kept quoting the first variant's price next
  // to an updated one — and kept quoting a single unit however many the shopper
  // put in the box. The widget is built by Afterpay's own script, which we do
  // not control, so all we can do is update the amount it reads and let it
  // redraw. Every lookup is guarded and the whole thing is wrapped: if the widget
  // is absent, shaped differently, or ignores us, the page behaves as before.
  // NOT verified against the live widget — see TODO.md.
  var AMOUNT_ATTRS = ['data-amount', 'data-purchase-amount'];
  // The price the app block itself rendered with (cents), from Liquid. Only used
  // to work out which unit it prints in — see readUnit.
  var seedCents = parseInt(root.dataset.kkUnitPrice, 10) || 0;

  // Dollars ("6.00") or cents ("600")? Settled once per element by matching what
  // the app printed against the price it rendered with, then remembered. An
  // amount that reads as neither is one we don't understand: leave it alone, a
  // stale row beats a corrupted one.
  function readUnit(el, attr) {
    if (el.__kkAmountUnit) return el.__kkAmountUnit;
    var raw = parseFloat(el.getAttribute(attr));
    var unit = null;
    if (isFinite(raw) && seedCents > 0) {
      if (Math.abs(raw - seedCents / 100) < 0.011) unit = 100;
      else if (Math.abs(raw - seedCents) < 1.01) unit = 1;
    }
    if (unit) el.__kkAmountUnit = unit;
    return unit;
  }

  function syncPaymentWidgets(v) {
    if (!v || typeof v.price !== 'number') return;
    // Quantity counts: the widget sits under the buy box quoting what this
    // purchase will cost, and a shopper stepping to 4 packs is shown four
    // instalments of the whole basket, not of one pack.
    var cents = v.price * currentQty() + extraSheetsCents();
    try {
      AMOUNT_ATTRS.forEach(function (attr) {
        root.querySelectorAll('[data-kk-app-block] [' + attr + ']').forEach(function (el) {
          var unit = readUnit(el, attr);
          if (!unit) return;
          var amount = unit === 100 ? (cents / 100).toFixed(2) : String(Math.round(cents));
          if (el.getAttribute(attr) === amount) return;
          el.setAttribute(attr, amount);
          el.dispatchEvent(new CustomEvent('change', { bubbles: true }));
        });
      });
    } catch (e) { /* a payment widget must never break the buy box */ }
  }

  // An app block can render nothing for a given product (Simple Bundles'
  // options block on a product that isn't an Infinite Options bundle, an
  // Afterpay widget outside its price range) and still leave its wrapper in the
  // price panel, which drew an empty grey row. Collapse a row while it holds
  // nothing a shopper can see, and bring it back the moment the app fills it in
  // (the wrapper stays laid out while collapsed, so the observers still fire).
  function appRowHasContent(row) {
    if ((row.innerText || '').trim()) return true;
    var els = row.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var tag = el.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'TEMPLATE' || tag === 'LINK' || tag === 'META') continue;
      var media = /^(IMG|SVG|IFRAME|VIDEO|CANVAS|PICTURE|SELECT|INPUT|BUTTON|TEXTAREA|OBJECT|EMBED)$/i.test(tag);
      // Custom elements (afterpay-placement, …) draw into a shadow root the
      // text check can't see.
      if (!media && tag.indexOf('-') === -1 && !el.shadowRoot) continue;
      if (tag === 'INPUT' && el.type === 'hidden') continue;
      var box = el.getBoundingClientRect();
      if (box.width > 0 && box.height > 0) return true;
    }
    return false;
  }

  function watchAppRows() {
    var rows = root.querySelectorAll('.pdp-panel__row--app[data-kk-app-block]');
    if (!rows.length) return;
    function check(row) {
      try {
        var empty = !appRowHasContent(row);
        if (row.classList.contains('is-empty') !== empty) row.classList.toggle('is-empty', empty);
      } catch (e) { /* never break the buy box over a payment widget */ }
    }
    rows.forEach(function (row) {
      var queued = false;
      function schedule() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; check(row); });
      }
      check(row);
      if ('MutationObserver' in window) {
        new MutationObserver(schedule).observe(row, { childList: true, subtree: true, characterData: true, attributes: true });
      }
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(schedule);
        Array.prototype.forEach.call(row.children, function (c) { ro.observe(c); });
      }
    });
    // Late scripts (Afterpay loads async) can paint without touching the row's
    // own subtree — a last pass once the page has finished loading.
    if (document.readyState === 'complete') setTimeout(function () { rows.forEach(check); }, 1500);
    else window.addEventListener('load', function () { setTimeout(function () { rows.forEach(check); }, 1500); }, { once: true });
  }
  watchAppRows();

  // One call site for all of these, so a future addition can't be wired into only
  // half the paths (which is how the buy-now link got missed in the first place).
  // The price on the Add-to-cart button: selected variant x quantity. Its own
  // span (not the label span every ATC writer rewrites), so only this sets it.
  function syncAtcPrice(v) {
    var amount = root.querySelector('[data-kk-atc-price-amount]');
    if (!amount || !v || typeof v.price !== 'number' || !window.KKMoney) return;
    var text = window.KKMoney.fromCents(v.price * currentQty() + extraSheetsCents());
    if (amount.textContent !== text) amount.textContent = text;
  }

  // The trust strip's dispatch cell: no "Same-day dispatch" on a sold-out pick.
  // The trust strip's dispatch cell and the delivery line's dispatch item.
  function syncDispatch(v) {
    var on = physical(v);
    root.querySelectorAll('[data-kk-dispatch-cell]').forEach(function (cell) {
      if (cell.hidden !== !on) cell.hidden = !on;
    });
  }

  function syncSelection(v) {
    if (!v) return;
    syncAtcPrice(v);
    syncStock(v);
    syncDispatch(v);
    syncBuyNow(v);
    syncNotify(v);
    syncPaymentWidgets(v);
  }

  // The gallery column sticks (phase 7; CSS in the section). With the details
  // under the gallery it can be taller than the window, so stick it at the
  // usual offset when it fits, or at (window height - column height) so it
  // scrolls until its end is in view and then holds.
  var leftCol = root.querySelector('[data-kk-left]');
  if (leftCol) {
    var placeLeft = function () {
      var header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      var fit = header + 16;
      var top = Math.min(fit, window.innerHeight - leftCol.offsetHeight - 16);
      var value = Math.round(top) + 'px';
      if (leftCol.style.getPropertyValue('--kk-left-top') !== value) leftCol.style.setProperty('--kk-left-top', value);
    };
    placeLeft();
    window.addEventListener('resize', placeLeft);
    window.addEventListener('load', placeLeft);
    if ('ResizeObserver' in window) new ResizeObserver(placeLeft).observe(leftCol);
  }

  // Guests' wishlist heart (phase 7): a small sign-in prompt, closed by a
  // second press, a click elsewhere or Escape.
  var wishGuest = root.querySelector('[data-kk-wish-guest]');
  if (wishGuest) {
    var wishPop = document.getElementById(wishGuest.getAttribute('aria-controls'));
    var setWishPop = function (open) {
      if (!wishPop) return;
      wishPop.hidden = !open;
      wishGuest.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    wishGuest.addEventListener('click', function () {
      var open = wishPop && wishPop.hidden;
      setWishPop(open);
      if (open) { var link = wishPop.querySelector('a'); if (link) link.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (wishPop && !wishPop.hidden && !wishPop.contains(e.target) && !wishGuest.contains(e.target)) setWishPop(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wishPop && !wishPop.hidden) { setWishPop(false); wishGuest.focus(); }
    });
  }

  // Backstop for the disabled Buy-it-now: syncBuyNow strips the href, which is
  // already enough to make an <a> inert, but a stale href from any other path
  // must not reach checkout with an unavailable variant.
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-kk-buynow]');
    if (a && a.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Quantity moves the checkout link and the instalment amount too, and changes
  // through neither of the variant paths below.
  ['change', 'input'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (!e.target.classList || !e.target.classList.contains('quantity__input')) return;
      var sel = currentVariant();
      if (sel) syncSelection(sel);
    });
  });

  // Extra sheets chosen or cleared: the price on Add to cart follows.
  root.addEventListener('kk:extras-change', function () {
    var sel = currentVariant();
    if (sel) syncSelection(sel);
  });

  // The selected variant, read back from the form the buy paths actually submit.
  function currentVariant() {
    var input = root.querySelector('product-form input[name="id"]');
    return input ? variantById(input.value) : null;
  }

  function variantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function syncVariantDescription(v) {
    if (!variantDescription) return;
    var text = v && typeof v.description === 'string' ? v.description.trim() : '';
    if (variantDescription.textContent !== text) variantDescription.textContent = text;
    variantDescription.hidden = !text;
  }

  // Resolve the chosen variant ourselves and apply it (image + ATC + heart +
  // form id) the instant a variant is clicked. Dawn's product-info.js fetches
  // the section over the network and swaps it in; that pipeline is unreliable
  // inside a renamed section (the old quick-view modal: variant clicks did nothing there), so
  // we drive it directly from the embedded variant list — no round-trip.
  // Delegated on `root` (not the variant-selects element) because Dawn replaces
  // <variant-selects> on the first change — a direct listener would then be
  // detached and only the first switch would work ("swaps once, then stops").
  if (variants.length) {
    root.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('variant-selects')) return;
      var vs = root.querySelector('variant-selects');
      if (!vs) return;
      var chosen = [];
      vs.querySelectorAll('.product-form__input').forEach(function (group, gi) {
        // The shopper's own pick in the images option starts the filter
        // (not the option_none_default auto-pick).
        if (gi === viIndex && group.contains(e.target) && !e.target.hasAttribute('data-kk-auto-pick')) viArmed = true;
        var checked = group.querySelector('input:checked');
        if (checked) { chosen.push(checked.value); return; }
        var sel = group.querySelector('select');
        if (sel) chosen.push(sel.value);
      });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options || [];
        if (opts.length !== chosen.length) continue;
        var same = true;
        for (var j = 0; j < opts.length; j++) {
          if (String(opts[j]) !== String(chosen[j])) { same = false; break; }
        }
        if (same) { match = variants[i]; break; }
      }
      // Tell kkumi-pdp-buy-state.js (price, checking state, quantity line)
      // what the page could work out on its own: the variant, or a miss.
      // `complete` is false while an option is still blank (option rows).
      var groups = vs.querySelectorAll('.product-form__input').length;
      var local = { variant: match, complete: chosen.length === groups };
      if (!match) {
        root.dispatchEvent(new CustomEvent('kk:variant-local', { detail: local }));
        return;
      }
      // Defer so we run AFTER Dawn's own change handler, which synchronously
      // disables the button (and whose follow-up network fetch is what fails in
      // the modal, leaving it stuck). Running last means our state wins.
      setTimeout(function () {
        syncAtc(match);
        syncSelection(match);
        syncVariantDescription(match);
        syncGallery(match, match.media);
        var h = root.querySelector('.kk-pdp-wish-slot.kkumi-card__wish, .kkumi-card__wish');
        if (h && match.id) h.dataset.variantId = match.id;
        root.dispatchEvent(new CustomEvent('kk:variant-local', { detail: local }));
      }, 0);
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function(payload) {
      var d = payload && payload.data;
      if (!d) return;
      if (d.sectionId !== sectionId) return;
      var v = d.variant;
      if (!v) return;
      var incoming = d.html && d.html.querySelector('product-info[data-kk-variants]');
      if (incoming) {
        variants = parseJSONAttr(incoming, 'data-kk-variants');
        blocked = incoming.hasAttribute('data-kk-blocked');
        root.toggleAttribute('data-kk-blocked', blocked);
        var proof = incoming.querySelector('[data-kk-restock-available]');
        var existingProof = root.querySelector('[data-kk-restock-available]');
        if (proof && existingProof) existingProof.replaceWith(proof.cloneNode(true));
        else if (proof) root.appendChild(proof.cloneNode(true));
        else if (existingProof) existingProof.remove();
        if (window.KKNotify) window.KKNotify.sync();
      }
      // Keep the wishlist heart pointed at the selected variant so a save
      // captures the exact variant the customer is viewing (variant-level saves).
      var heart = root.querySelector('.kk-pdp-wish-slot.kkumi-card__wish, .kkumi-card__wish');
      if (heart && v.id) heart.dataset.variantId = v.id;

      // Defensively drive the Add-to-cart button straight off the variant
      // payload. In the old quick-view modal Dawn renamed the section and its
      // product-form.toggleSubmitButton can leave the ATC stuck disabled /
      // blank after a variant change (the reported "blanked-out ATC" bug). We
      // own the button state here so it always reflects the selected variant —
      // on the PDP this just reinforces what Dawn already did.
      syncAtc(v);
      syncSelection(variantById(v.id) || v);
      syncVariantDescription(variantById(v.id) || v);

      syncGallery(variantById(v.id), v.featured_media && v.featured_media.id);
      // The server's answer (after the hero has applied it).
      root.dispatchEvent(new CustomEvent('kk:variant-server', { detail: { variant: variantById(v.id) || v } }));
    });
  }

  // Thumb-strip pagination — picks whichever axis has the most overflow
  // (vertical on the PDP, horizontal on a narrow column). Buttons hide
  // themselves at the scroll edges.
  var thumbsCol = root.querySelector('[data-kk-thumbs="' + sectionId + '"]');
  var moreBtn = root.querySelector('[data-kk-thumbs-more="' + sectionId + '"]');
  var prevBtn = root.querySelector('[data-kk-thumbs-prev="' + sectionId + '"]');
  if (thumbsCol && (moreBtn || prevBtn)) {
    function isHorizontal() {
      return thumbsCol.scrollWidth - thumbsCol.clientWidth >
             thumbsCol.scrollHeight - thumbsCol.clientHeight;
    }
    function step(dir) {
      if (isHorizontal()) {
        var dx = thumbsCol.clientWidth * 0.8 * dir;
        thumbsCol.scrollTo({ left: thumbsCol.scrollLeft + dx, behavior: 'smooth' });
      } else {
        var dy = thumbsCol.clientHeight * 0.8 * dir;
        thumbsCol.scrollTo({ top: thumbsCol.scrollTop + dy, behavior: 'smooth' });
      }
    }
    function updateEdges() {
      var atStart, atEnd;
      // Measured, not counted: the desktop rail is as tall as the main
      // image, so how many thumbs fit depends on the image, not a setting.
      var overflows = thumbsCol.scrollHeight - thumbsCol.clientHeight > 1 ||
                      thumbsCol.scrollWidth - thumbsCol.clientWidth > 1;
      thumbsCol.classList.toggle('has-overflow', overflows);
      if (thumbsCol.parentNode) thumbsCol.parentNode.classList.toggle('is-static', !overflows);
      if (isHorizontal()) {
        atStart = thumbsCol.scrollLeft <= 1;
        atEnd = thumbsCol.scrollLeft + thumbsCol.clientWidth >= thumbsCol.scrollWidth - 1;
      } else {
        atStart = thumbsCol.scrollTop <= 1;
        atEnd = thumbsCol.scrollTop + thumbsCol.clientHeight >= thumbsCol.scrollHeight - 1;
      }
      if (prevBtn) prevBtn.toggleAttribute('hidden', atStart);
      if (moreBtn) moreBtn.toggleAttribute('hidden', atEnd);
      // Drives the start-side edge-fade: present once the user has
      // scrolled past the start of the strip (i.e. the back chevron is
      // visible). End-side fade stays on whenever there's overflow.
      thumbsCol.classList.toggle('is-scrolled', !atStart);
    }
    if (moreBtn) moreBtn.addEventListener('click', function() { step(1); });
    if (prevBtn) prevBtn.addEventListener('click', function() { step(-1); });
    thumbsCol.addEventListener('scroll', updateEdges, { passive: true });
    // DOMContentLoaded fires before lazy-loaded thumb images settle layout,
    // so the initial scrollHeight can be wrong and both edge buttons get
    // hidden until the user scrolls. Re-run whenever the strip's box
    // changes size (also covers viewport resize crossing the breakpoint).
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(updateEdges).observe(thumbsCol);
    } else {
      window.addEventListener('resize', updateEdges);
      window.addEventListener('load', updateEdges);
    }
    updateEdges();
    refreshThumbStrip = updateEdges;
  }

  // A refresh starts from the defaults (setting update_url off): once a
  // ?variant= link has opened its variant, drop the parameter from the
  // address bar, so reloading doesn't reopen it. After window load, so the
  // option rows and the "no" default below have read the link first. Only
  // on the product page itself, not a copy of the hero in a dialog.
  function dropVariantParam() {
    if (!/[?&]variant=/.test(window.location.search) || !window.history || !window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('variant');
    var query = params.toString();
    window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
  }
  if (root.dataset.updateUrl === 'false' && !root.closest('modal-dialog, dialog')) {
    if (document.readyState === 'complete') setTimeout(dropVariantParam, 0);
    else window.addEventListener('load', function () { setTimeout(dropVariantParam, 0); }, { once: true });
  }

  // Optional native options start on their "no" value (setting
  // option_none_default; Simple Bundles app options do it in Liquid). Dawn
  // renders the first available variant, so on load each native option with
  // an unpicked, available data-kk-none value is switched to it, one per
  // re-render, until none is left or the shopper touches the options. Never
  // when the link names a variant.
  var nonePending = root.hasAttribute('data-kk-none-default') && !/[?&]variant=/.test(window.location.search);
  var noneDone = {}; // radio group name -> switched once; never fight a re-render
  function settleNone() {
    if (!nonePending) return;
    var target = null;
    Array.prototype.some.call(root.querySelectorAll('variant-selects fieldset.var-block'), function (fs) {
      var vs = fs.closest('variant-selects');
      if (vs && vs.style.display === 'none') return false;
      var none = fs.querySelector('input[type="radio"][data-kk-none]:not(.disabled):not(:disabled)');
      if (!none || none.checked || noneDone[none.name]) return false;
      noneDone[none.name] = true;
      target = none;
      return true;
    });
    if (!target) { nonePending = false; return; }
    target.setAttribute('data-kk-auto-pick', '');
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }
  ['pointerdown', 'keydown'].forEach(function (type) {
    root.addEventListener(type, function (e) {
      if (e.isTrusted && e.target.closest && e.target.closest('variant-selects, [data-kk-opt-rows]')) nonePending = false;
    }, true);
  });
  if (nonePending) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(settleNone, 0); });
    }
    settleNone();
  }

  // Lightbox
  var dialog = document.querySelector('dialog[data-kk-lightbox="' + sectionId + '"]');
  if (dialog) {
    var lbImg = dialog.querySelector('.kk-pdp-lightbox__img');
    var closeBtn = dialog.querySelector('.kk-pdp-lightbox__close');
    var trigger = root.querySelector('[data-kk-zoom-trigger="' + sectionId + '"]');
    if (trigger) {
      trigger.addEventListener('click', function() {
        if (lbImg && fullUrls[current]) {
          lbImg.src = fullUrls[current];
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }
      });
    }
    closeBtn.addEventListener('click', function() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }
    });
  }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  /* Share-button copy-link toast — reuses the wishlist toast pattern */
  (function () {
    var copyButtons = document.querySelectorAll('share-button .pdp-buy__share-btn');
    if (!copyButtons.length) return;

    function showToast(anchor, msg) {
      var t = document.querySelector('.kk-wish-toast-global');
      if (!t) {
        t = document.createElement('div');
        t.className = 'kk-wish-toast-global';
        t.setAttribute('aria-live', 'polite');
        document.body.appendChild(t);
      }
      var rect = anchor.getBoundingClientRect();
      t.textContent = msg;
      t.style.top = (rect.top + window.scrollY - 40) + 'px';
      var raw = rect.left + rect.width / 2;
      var w = t.offsetWidth || 120;
      t.style.left = Math.min(Math.max(raw, w / 2 + 16), window.innerWidth - w / 2 - 16) + 'px';
      t.classList.remove('is-visible');
      void t.offsetWidth;
      t.classList.add('is-visible');
      clearTimeout(t._kkTimer);
      t._kkTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
    }

    copyButtons.forEach(function (btn) {
      if (btn.dataset.kkShareBound === '1') return;
      btn.dataset.kkShareBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var url = window.location.href;
        var host = btn.closest('share-button');
        var copiedMsg = (host && host.dataset.copiedToast) || 'Link copied';
        var failedMsg = (host && host.dataset.copyFailedToast) || 'Copy failed';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(
            function () { showToast(btn, copiedMsg); },
            function () { showToast(btn, failedMsg); }
          );
        } else {
          showToast(btn, copiedMsg);
        }
      });
    });
  })();
